import React from 'react';
import {
    TextField,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {useTranslation} from "react-i18next";

const ConnectorFormStatusAfterExport = ({ connectorExportStatuses, exportStatus, setExportStatus, ...rest }) => {
    const {t} = useTranslation('connector');

    return (
        <Autocomplete
            options={connectorExportStatuses}
            value={ exportStatus ? connectorExportStatuses.find(ces => ces.id == exportStatus) : null }
            onChange={ (event, status) => {setExportStatus(status ? status.id : null);} }
            getOptionLabel={(option) => option.name}
            renderInput={(params) => <TextField {...params} label={t('label.statuses')} placeholder={t('label.statuses')} />}
        />
    );
}

export default ConnectorFormStatusAfterExport;